import { useState, useCallback } from "react";

const usePop = ({ setting = [] } = {}) => {
  // 是否顯示彈出視窗
  const [isPop, setIsPop] = useState(
    setting.reduce((pre, cur) => ({ ...pre, [cur.key]: cur }), {})
  );
  // 彈出視窗資料
  const [popData, setPopData] = useState({
    type: "", // 開啟的pop
    data: {}, // 資料
  });

  // 開啟 彈出視窗
  const openPop = useCallback(
    (options) => {
      setPopData(options);
      setIsPop({
        ...Object.values(isPop).reduce(
          (pre, cur) => ({
            ...pre,
            [cur.key]: {
              ...cur,
              isOpen: false,
            },
          }),
          {}
        ),
        [options.type]: {
          ...isPop[options.type],
          isOpen: true,
        },
      });
    },
    [isPop]
  );

  // 關閉 彈出視窗
  const closePop = useCallback(
    (options) => {
      let type = options.type ?? popData.type;
      setIsPop((state) => ({
        ...state,
        [type]: {
          ...isPop[type],
          isOpen: false,
        },
      }));
    },
    [isPop]
  );

  return {
    isPop,
    setIsPop,
    popData,
    setPopData,
    openPop,
    closePop,
  };
};

export default usePop;
